import { useEffect } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Divider,
    Grid,
} from "@mui/material";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";
import * as yup from "yup";
import TextInput from "../../../main/components/TextInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
    name: yup.string().required("Nome é obrigatório")
});

export type NewCluster = yup.InferType<typeof schema>;

export function AddClusterFormModal(props: {
    showAddFormModal: boolean;
    setShowAddFormModal: (value: boolean) => void;
    itemName: string;
    setNewCluster: (cluster: string) => void;
}) {
    const {
        showAddFormModal,
        setShowAddFormModal,
        itemName,
        setNewCluster
    } = props;

    const onClose = () => setShowAddFormModal(false);

    const {
        handleSubmit,
        control,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema),
    });

    const onSubmit = (data: NewCluster) => {
        setNewCluster(data.name);
        onClose();
    };

    useEffect(() => {
        if (!showAddFormModal) {
            return;
        }
    }, [showAddFormModal]);

    return (
        <>
            <Dialog
                onClose={onClose}
                aria-labelledby="customized-dialog-title"
                open={showAddFormModal}
                maxWidth="xs"
                fullWidth
            >
                <DialogHeader id="customized-dialog-title" onClose={onClose}>
                    {`Adicionar ${itemName} `}
                </DialogHeader>
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                    }}
                    dividers
                >
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextInput
                                    control={control}
                                    fieldName="name"
                                    label="Nome"
                                    errors={errors}
                                    sx={{ width: "100%", marginBottom: "10px" }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <DialogActions>
                                <Button color="secondary" onClick={onClose}>
                                    {"Cancelar"}
                                </Button>
                                <Button variant="contained" color="primary" type="submit">
                                    {"Confirmar"}
                                </Button>
                            </DialogActions>
                        </Grid>
                    </form>
                </DialogContent>
            </Dialog>
        </>
    );
}
